export const BrandPillSelection = ({makes, selectedBrandIds, onFilterChange}) => {
    const toggleSelection = (brandId) => {
        let newSelection;
        if (selectedBrandIds.includes(brandId)) {
            newSelection = selectedBrandIds.filter(id => id !== brandId);
        } else {
            newSelection = [...selectedBrandIds, brandId];
        }
        onFilterChange(newSelection);
    };

    return (
        <div className="">
            {makes.map((make) => (
                    <div key={make.make_id} className="mr-3 mb-1">
                        <div id={'make-' + make.make_id} onClick={() => toggleSelection(make.make_id)} className={`relative flex items-center justify-start cursor-pointer hover:scale-[1.1] transition duration-150 ease-in-out py-1 bg-white border-b border-b-gray-300`}>
                            <div className="absolute top-0 right-0 rounded opacity-25 bg-gray-400 w-full h-full" style={{display: selectedBrandIds.includes(make.make_id) ? 'block' : 'none'}}/>
                            <div className="mr-1" style={{display: make.make_logo === null ? 'none' : 'block'}}>
                                <img src={make.make_logo} alt={make.make_name} className="h-4"/>
                            </div>
                            <div className="text-xs uppercase px-2">
                                {make.make_name}
                            </div>
                        </div>
                    </div>
                )
            )}
        </div>
    )
        ;
}